/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocalHospitalIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-local-hospital"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.05 13.95L10.05 15.43Q10.05 16.25 10.64 16.82Q11.22 17.4 12.05 17.4Q12.88 17.4 13.45 16.81Q14.03 16.23 14.03 15.4L14.03 13.95L15.43 13.95Q16.25 13.95 16.82 13.36Q17.4 12.78 17.4 11.95Q17.4 11.13 16.82 10.55Q16.25 9.97 15.43 9.97L14.03 9.97L14.03 8.57Q14.03 7.75 13.45 7.17Q12.88 6.6 12.05 6.6Q11.22 6.6 10.64 7.17Q10.05 7.75 10.05 8.57L10.05 9.97L8.57 9.97Q7.75 9.97 7.17 10.55Q6.6 11.13 6.6 11.95Q6.6 12.78 7.19 13.36Q7.78 13.95 8.6 13.95ZM5 21.65Q3.9 21.65 3.13 20.88Q2.35 20.1 2.35 19L2.35 5Q2.35 3.9 3.13 3.13Q3.9 2.35 5 2.35L19 2.35Q20.1 2.35 20.88 3.13Q21.65 3.9 21.65 5L21.65 19Q21.65 20.1 20.88 20.88Q20.1 21.65 19 21.65Z" fill={color} />
    </svg>
  );
}
